import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  BsChevronRight,
  BsGeoAlt,
  BsEnvelopeAt,
  BsClock,
  BsTelephone,
} from "react-icons/bs";
import { BsFacebook, BsInstagram, BsWhatsapp, BsYoutube } from "react-icons/bs";

// Aos animation
import "aos/dist/aos.css";
import Aos from "aos";
import { Link } from "react-router-dom";

export default function Footer() {
  // AOS initialize
  useEffect(() => {
    Aos.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <>
      <footer className="footer-section ">
        <Container>
          <Row className="gy-2">
            {/* Services */}
            <Col md={6} lg={3}>
              <h5 className="fw-bold mb-3">Services</h5>
              <ul className="footer-links text-start">
                <Link to="/tour-packages/andaman-budget-tour">
                  <li>
                    <BsChevronRight className="me-2" /> Tour Booking
                  </li>
                </Link>
                <Link to="/carrental">
                  <li>
                    <BsChevronRight className="me-2" /> Car Rental
                  </li>
                </Link>
                <Link to="/hotellist">
                  <li>
                    <BsChevronRight className="me-2" /> Hotel Booking
                  </li>
                </Link>
                <Link to="/ferry">
                  <li>
                    <BsChevronRight className="me-2" /> Ferry Booking
                  </li>
                </Link>
                <Link to="/watersports">
                  <li>
                    <BsChevronRight className="me-2" /> Water Sports Booking
                  </li>
                </Link>
              </ul>
            </Col>

            {/* Policy */}
            <Col md={6} lg={3}>
              <h5 className="fw-bold mb-3">Policy</h5>
              <ul className="footer-links text-start">
                <Link to="/payment-policy">
                  {" "}
                  <li>
                    <BsChevronRight className="me-2" /> Payment Policy
                  </li>{" "}
                </Link>
                <Link to="/refund">
                  {" "}
                  <li>
                    <BsChevronRight className="me-2" /> Refund Policy
                  </li>{" "}
                </Link>
                <Link to="/websiteusage">
                  <li>
                    <BsChevronRight className="me-2" /> Website Usage Policy
                  </li>
                </Link>
                <Link to="/terms-conditions">
                  <li>
                    <BsChevronRight className="me-2" /> Terms and Conditions
                  </li>
                </Link>
                <Link to="/cookie">
                  <li>
                    <BsChevronRight className="me-2" /> Cookie Policy
                  </li>
                </Link>
                <Link to="/privacy-policy">
                  <li>
                    <BsChevronRight className="me-2" /> Privacy Policy
                  </li>
                </Link>
              </ul>
            </Col>

            {/* Packages */}
            <Col md={6} lg={3}>
              <h5 className="fw-bold mb-3">Packages</h5>
              <ul className="footer-links text-start">
                <Link to="/tour-packages/honeymoon-package">
                  <li>
                    <BsChevronRight className="me-2" /> Honeymoon Packages
                  </li>
                </Link>
                <Link to="/tour-packages/group-tour-package">
                  <li>
                    <BsChevronRight className="me-2" /> Group Tour Packages
                  </li>
                </Link>
                <Link to="/tour-packages/family-package">
                  <li>
                    <BsChevronRight className="me-2" /> Family Holidays
                  </li>
                </Link>
              </ul>
            </Col>

            {/* Get in Touch */}
            {/* Get in Touch */}
            <Col md={6} lg={3}>
              <h5 className="fw-bold mb-3">Get In Touch</h5>
              <ul className="footer-contact text-start">
                <li>
                  <BsGeoAlt className="text-warning me-2" />
                  Andaman, India
                </li>

                <li>
                  <a
                    href="mailto:andamanmakeholidayss@gmail.com"
                    className="d-flex flex-row align-items-center text-white"
                    style={{ textDecoration: "none" }}
                  >
                    <BsEnvelopeAt className="text-warning me-2" />
                    andamanmakeholidayss@gmail.com
                  </a>
                </li>

                <li>
                  <BsClock className="text-warning me-2" />
                  Mon - Sat, 08am - 05pm
                </li>

                <li>
                  <a
                    href="tel:+919933275913"
                    className="d-flex flex-row align-items-center text-white"
                    style={{ textDecoration: "none" }}
                  >
                    <BsTelephone className="text-warning me-2" />
                    +91-9933275913
                  </a>
                </li>
              </ul>
              {/* Social Media */}
              <div className="footer-social mt-3">
                <a
                  href="https://www.facebook.com/profile.php?id=61564282047804"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <BsFacebook />
                </a>

                <a
                  href="https://www.instagram.com/andamanmakeholidays"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <BsInstagram />
                </a>

                {/* <a
                  href="https://wa.me/919933275913"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                >
                  <BsWhatsapp />
                </a>

                <a
                  href="https://www.youtube.com/@andamanmakeholidays"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <BsYoutube />
                </a> */}
              </div>
            </Col>
          </Row>
        </Container>

        <section className="footer-bottom">
          <Container className="d-flex flex-column flex-md-row justify-content-between  align-items-center  text-center container position-relative">
            <p className="mb-0 copyright-text">
              © <span className="">Andaman Make Holidays</span> | All Rights
              Reserved
            </p>
            <p className="mt-2 mt-md-0">
              <a
                href="https://octaloptimum.com/"
                target="_blank"
                rel="octalOptimumwebsite"
              >
                Powered By Octal Optimum
              </a>
            </p>
          </Container>
        </section>
      </footer>

      {/* Scroll to top button */}
      <Scrollfooterbtn />
    </>
  );
}

// Scroll to Top Button Component
export const Scrollfooterbtn = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 250);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* {showButton && (
        <Button
          onClick={scrollToTop}
          className="scroll-top-btn rounded-circle"
          aria-label="Scroll to top"
        >
          <BsArrowUp size={20} />
        </Button>
      )} */}
    </>
  );
};
